import i18n from "../config/i18n";

class LanguageManager {
    constructor() {
        this.dictionaries = i18n;
        this.autoDetectLang();
    }

    autoDetectLang() {
        let lang = window.localStorage.getItem('app_i18n');
        if (!lang) {
            lang = this.setDefaultInMemory();
        }
        this.setLang(lang);
    }

    saveLang(lang) {
        window.localStorage.setItem('app_i18n', lang);
        return this;
    }

    setDefaultInMemory() {
        this.saveLang(i18n.default);
        return i18n.default;
    }

    getLang() {
        return this._lang;
    }

    setLang(lang) {
        this._lang = lang;
        this._dict = this.dictionaries[this._lang];
        return this;
    }

    doesLangExist(lang) {
        return (this.dictionaries[this._lang] ? true : false);
    }

    get(key, vars, fallbackStr) {
        return this._dict[key];
    }

    T(key, vars, fallbackStr) {
        return this.get(key, vars, fallbackStr);
    }
}

export const languageManager = new LanguageManager();

export const T = (key, vars, fallbackStr) => {
    return languageManager.get(key, vars, fallbackStr);
};

export default languageManager;